import watchDeleteAccountSaga from '@/store/sagas/authentication/deleteAccountSaga';
import watchReactivateAccountSaga from '@/store/sagas/authentication/reactivateAccountSaga';

import watchAuthenticationSaga from './authenticationSaga';
import watchFetchLoggedInUserSaga from './loggedInUserSaga';
import watchPersistAuthenticateSaga from './persistAuthenticateSaga';

const authenticationSagas = [
  watchAuthenticationSaga(),
  watchPersistAuthenticateSaga(),
  watchFetchLoggedInUserSaga(),
  watchDeleteAccountSaga(),
  watchReactivateAccountSaga(),
];

export default authenticationSagas;
